// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vdo_txt {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
@media screen and (max-width: 575px) {
  .ved_txt {
    justify-content: center !important;
  }
}

@media screen and (max-width: 900px) {
  .MeImage {
    margin-top: 75px;
  }
  .MainDivWritePitch {
    padding-top: 70px;
  }
}
@media screen and (max-width: 767px) {
  .pitchButton {
    display: block;
    /* justify-content: space-between; */
  }
  .pitchTextVideo {
    float: left !important;
  }
}

/* animation */

.pitch_dots-container {
  display: inline-flex;
  align-items: center;
}

.pitch_dot {
  height: 9px;
  width: 8px;
  margin-right: 10px;
  border-radius: 10px;
  background-color: #b3d4fc;
  animation: pulse 1.5s infinite ease-in-out;
}

.pitch_dot:last-child {
  margin-right: 0;
}

.pitch_dot:nth-child(1) {
  animation-delay: -0.3s;
}

.pitch_dot:nth-child(2) {
  animation-delay: -0.1s;
}

.pitch_dot:nth-child(3) {
  animation-delay: 0.1s;
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    background-color: #044491;
    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);
  }

  50% {
    transform: scale(1.2);
    background-color: #214eb6;
    box-shadow: 0 0 0 10px rgba(178, 212, 252, 0);
  }

  100% {
    transform: scale(0.8);
    background-color: #569bee;
    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component new/WritePitch.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;AACA;EACE;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EAIA;IACE,iBAAiB;EACnB;AALF;AAOA;EACE;IACE,cAAc;IACd,oCAAoC;EACtC;EAGA;IACE,sBAAsB;EACxB;AAJF;;AAOA,cAAc;;AAEd;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,qBAAqB;IACrB,yBAAyB;IACzB,4CAA4C;EAC9C;;EAEA;IACE,qBAAqB;IACrB,yBAAyB;IACzB,6CAA6C;EAC/C;;EAEA;IACE,qBAAqB;IACrB,yBAAyB;IACzB,4CAA4C;EAC9C;AACF","sourcesContent":[".vdo_txt {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n@media screen and (max-width: 575px) {\n  .ved_txt {\n    justify-content: center !important;\n  }\n}\n\n@media screen and (max-width: 900px) {\n  .MeImage {\n    margin-top: 75px;\n  }\n}\n\n@media screen and (max-width: 900px) {\n  .MainDivWritePitch {\n    padding-top: 70px;\n  }\n}\n@media screen and (max-width: 767px) {\n  .pitchButton {\n    display: block;\n    /* justify-content: space-between; */\n  }\n}\n@media screen and (max-width: 767px) {\n  .pitchTextVideo {\n    float: left !important;\n  }\n}\n\n/* animation */\n\n.pitch_dots-container {\n  display: inline-flex;\n  align-items: center;\n}\n\n.pitch_dot {\n  height: 9px;\n  width: 8px;\n  margin-right: 10px;\n  border-radius: 10px;\n  background-color: #b3d4fc;\n  animation: pulse 1.5s infinite ease-in-out;\n}\n\n.pitch_dot:last-child {\n  margin-right: 0;\n}\n\n.pitch_dot:nth-child(1) {\n  animation-delay: -0.3s;\n}\n\n.pitch_dot:nth-child(2) {\n  animation-delay: -0.1s;\n}\n\n.pitch_dot:nth-child(3) {\n  animation-delay: 0.1s;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(0.8);\n    background-color: #044491;\n    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);\n  }\n\n  50% {\n    transform: scale(1.2);\n    background-color: #214eb6;\n    box-shadow: 0 0 0 10px rgba(178, 212, 252, 0);\n  }\n\n  100% {\n    transform: scale(0.8);\n    background-color: #569bee;\n    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
